<div class="profile-page bg-secondary">
    <main class="pt-4">
        <div class="container wow fadeIn">
            <legend>Users</legend>
            <div class="row">
                <div>
                    <b-form inline>
                        <label class="sr-only" for="inline-form-input-name">Username / Email</label>
                        <b-form-input v-model="username" id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0"
                            placeholder="username/email"></b-form-input>
                        <label class="mr-sm-2" for="inline-form-custom-select-pref">Search Type</label>
                        <b-form-select v-model="exact" id="inline-form-custom-select-pref" class="mb-2 mr-sm-2 mb-sm-0"
                            :options="[{ text: 'Scan Search', value: 'scan' }, { text: 'Exact Search', value: 'exact' },{ text: 'Agent Code', value: 'agent' }]"
                            :value="null"></b-form-select>

                        <b-button @click="onSearch()" variant="primary">Search</b-button>
                    </b-form>
                </div>
                <br />
                <br />
            </div>
            <!--Grid row-->
            <div class="row">
                <div class="table-responsive">
                    <b-table striped hover :items="items" :fields="fields">
                        <template #cell(createdOn)="data">
                            <span>{{data.item.createdOn | formateDate}}</span>
                        </template>
                        <template #cell(id)="data">
                            <router-link class="btn btn-primary" :to="{
                              name: 'deposit',
                              params: {
                                userId: data.item.id,
                                username: data.item.userName,
                                email: data.item.email,
                                fullName:data.item.fullName
                              },
                            }">Top Up</router-link>

                            <router-link class="btn btn-default" :to="{
                              name: 'customertransactions',
                              params: {
                                userId: data.item.id,
                              },
                            }">Transaction</router-link>

                            <router-link class="btn btn-default" :to="{
                              name: 'customeroveraltransactions',
                              params: {
                                userId: data.item.id,
                              },
                            }">Overal Transactions</router-link>

                            <router-link class="btn btn-primary" :to="{
                                name: 'whatsapp',
                                params: {
                                  userId: data.item.id,
                                  username: data.item.userName,
                                  email: data.item.email,
                                  currentWhatsapp:data.item.whatsApp,
                                  fullName:data.item.fullName
                                },
                              }">Whatsapp number</router-link>
                        </template>
                    </b-table>
                </div>
            </div>
            <!--Grid row-->
        </div>
    </main>
    <!--Main layout-->
</div>